import {
  formatIsoCivilDate,
  isValidCivilDate,
  parseCivilDate,
  parseIsoCivilDate,
} from "@/lib/civil-date";
import { toBackendEventDate } from "@/lib/mappers/gift-list";

/**
 * Civil dates for the public search.
 *
 * Calendar arithmetic lives in `@/lib/civil-date`; only the conversions the search needs,
 * between the browser format and the backend's, are here.
 */

export { isValidCivilDate };

export function toBackendSearchDate(input: string): string {
  if (!isValidCivilDate(input)) {
    throw new TypeError("Data civil inválida.");
  }

  return toBackendEventDate(input);
}

/**
 * Normalizes to `yyyy-mm-dd`. Accepts both formats because the public response is not
 * consistent about which one it returns.
 */
export function parsePublicEventDate(input: unknown): string | null {
  const parts = parseCivilDate(input);

  return parts === null ? null : formatIsoCivilDate(parts);
}


/** Re-exported for callers that only need strict ISO, without the Brazilian format. */
export { parseIsoCivilDate };

const SHORT_MONTHS = ["jan", "fev", "mar", "abr", "mai", "jun", "jul", "ago", "set", "out", "nov", "dez"];

/**
 * The list card's support line: "29 mai 2030 · Salvador" (Busca de Listas, `dataCidade`).
 *
 * The place is the host's free text, **whole**. The reference cut it at the first comma
 * (`local.split(',')[0]`), which read well for "Salvador, BA" and threw away most of what a host
 * actually writes: "Fazenda Vila Rica, Itu - SP" came out as "Fazenda Vila Rica". Now that the
 * field is explicitly "as it is on the invitation" (ruling of 2026-10-07), cutting it discards
 * the answer.
 *
 * So the line can now be long, and nothing here or in the card shortens it: the card's own rule
 * is `overflow-wrap: anywhere` (`.tb-public-list-card-date`), which wraps rather than truncates.
 * Stated plainly because it is a consequence, not an oversight — a clamp is a design decision,
 * and nobody has made it.
 *
 * A missing date keeps the card's existing "Data não informada"; a missing place drops the
 * separator rather than leaving it dangling.
 */
export function toCardDateAndPlace(eventDate: unknown, eventLocation: string | null): string {
  const parts = parseCivilDate(eventDate);
  const date =
    parts === null ? "Data não informada" : `${parts.day} ${SHORT_MONTHS[parts.month - 1]} ${parts.year}`;
  const place = eventLocation?.trim() ?? "";

  return place === "" ? date : `${date} · ${place}`;
}
